/*
 * @Date: 2020-08-31 14:09:19
 * @Author: MX
 * @LastEditTime: 2020-08-31 19:48:42
 * @Description: vuex
 */
import * as Types from '../mutation-types'
const base = {
    state:{
        user: JSON.parse(localStorage.getItem('userData')) || null, // 用户信息
        token: localStorage.getItem('YL_TOKEN') || '',
        uuid: localStorage.getItem('uuid') || '',
        appId: localStorage.getItem('appId') || ''
    },
    mutations:{
         // 用户信息
     [Types.SET_USER]: (state, data) => {
        state.user = data
        localStorage.setItem('userData', JSON.stringify(data))
      },
      // 用户token
      [Types.SET_TOKEN]: (state, data) => {
        state.token = data
        localStorage.setItem('YL_TOKEN', data)
      },
      // 用户默认应该ID
      [Types.SET_APPID]: (state, data) => {
        state.appId = data
        localStorage.setItem('appId', data)
      },
      // 用户uuid
      [Types.SET_UUID]: (state, data) => {
        state.uuid = data
        localStorage.setItem('uuid', data)
      },
        // 退出
        [Types.LOGIN_OUT]: state => {
            // 退出登录，清楚本地缓存
            localStorage.removeItem('userData')
            localStorage.removeItem('YL_TOKEN')
            localStorage.removeItem('uuid')
            localStorage.removeItem('appId')
            state.token = ''
            state.user = {}
            state.uuid = ''
            state.appId = ''
        },
    },
    actions:{
         // 登录初始化
        [Types.LOGIN_INIT]({ commit } = {}, value) {
           const { user, token, appId } = value
           commit('SET_USER', user)
           commit('SET_TOKEN', token)
           commit('SET_APPID', appId)
        },
         // 登录初始化 appId
         [Types.LOGIN_INIT_APPID]({ commit } = {}, value) {
          const { appId } = value
          commit('SET_APPID', appId)
       },
        // 退出
        [Types.LOGIN_OUT]({ commit } = {}) {
              commit('LOGIN_OUT')
        },
        // uuid
        [Types.SET_UUID]({ commit } = {},value){
          commit('SET_UUID',value)
        }

    },
    getters: {
        user: state => state.user,
        token: state => state.token || '',
        uuid: state => state.uuid || '',
        appId: state => state.appId || '',
    },

    
}
export default base